<template>
  <div class="container login-container">
    <h4 class="mt-3">Login</h4>
    <b-form @submit.prevent="login">
      <b-form-group id="input-group-username" label="Nome de usuário" label-for="input-username">
        <b-form-input id="input-username" v-model="username" required placeholder="Digite o login"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-password" label="Senha:" label-for="input-password">
        <b-form-input
          id="input-password"
          v-model="password"
          type="password"
          required
          placeholder="Digite a sua senha"
        ></b-form-input>
      </b-form-group>
      <b-alert v-model="errorState" variant="danger" dismissible>
        {{
        errorMessage ||
        "Ocorreu um erro inesperado, contate o administrador da aplicação"
        }}
      </b-alert>
      <b-button type="submit" variant="primary" class="mr-2 mb-2">
        <b-spinner v-if="loading" small class="mr-2"></b-spinner>Login
      </b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      errorState: false,
      errorMessage: ""
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.badCredentials = false;
      this.$store
        .dispatch("retrieveToken", {
          username: this.username,
          password: this.password
        })
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "home" });
          this.$store.dispatch("retrieveGroups");
          this.$store.dispatch("retrieveAvailableFeatures");
        })
        .catch(error => {
          this.loading = false;
          this.errorState = true;
          console.log(error);
          this.errorMessage = "Não foi possível autenticar, verifique suas credenciais. Se o erro persistir contate do administrador da aplicação";
        });
    }
  }
};
</script>

<style>
.login-container {
  max-width: 600px;
}
</style>
